
import React from "react";
import { useTranslations } from "use-intl";
import StatsCard from '@/components/dashboard/StatsCard';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

interface FinancialSummaryProps {
  financialData: {
    bankBalance: {
      value: string;
      trend: {
        value: number;
        positive: boolean;
      };
    };
    receivables: {
      value: string;
      trend: {
        value: number;
        positive: boolean;
      };
    };
    payables: {
      value: string;
      trend: {
        value: number;
        positive: boolean;
      };
    };
  };
}

const FinancialSummary: React.FC<FinancialSummaryProps> = ({ financialData }) => {
  const t = useTranslations('consultantTransactions.dashboard');
  return (
    <Card className="flex flex-col light-blue-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          {t('cashFlow.title')}
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 flex-grow">
        <div className="grid gap-4">
          <StatsCard 
            label={t('cashFlow.bankBalance')}
            value={financialData.bankBalance.value} 
            trend={financialData.bankBalance.trend} 
            className="border-l-4 border-l-primary" 
          />
          <StatsCard
            label={t('cashFlow.receivables')}
            value={financialData.receivables.value}
            trend={financialData.receivables.trend}
            className="border-l-4 border-l-primary"
          />
          <StatsCard
            label={t('cashFlow.payables')}
            value={financialData.payables.value}
            trend={financialData.payables.trend}
            className="border-l-4 border-l-primary"
          />
        </div>
      </CardContent>
      <CardFooter className="text-xs text-muted-foreground mt-auto pt-2 border-t">
        {t('lastUpdated', { minutes: 5 })}
      </CardFooter>
    </Card>
  );
};

export default FinancialSummary;
